import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChatService } from '../../../service/chat.service';
import { MessageType } from '../../../model/message-type';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PredefinedMessage } from '../../../model/predefined-message';
import { DECLARED_ICONS } from 'src/app/top-bar/util/message-util';
import { messageTypeValidator } from 'src/app/shared/util/validators';

@Component({
  selector: 'app-predefined-message-form',
  templateUrl: './predefined-message-form.component.html',
  styleUrls: ['./predefined-message-form.component.scss']
})
export class PredefinedMessageFormComponent implements OnInit {

  readonly ICONS: IconMessageTypeMap[] = DECLARED_ICONS;

  form: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PredefinedMessage, private chatService: ChatService,
  private ref: MatDialogRef<PredefinedMessageFormComponent>) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      id: new FormControl(this.data.id),
      icon: new FormControl(this.data.icon, [Validators.required, messageTypeValidator]),
      message: new FormControl(this.data.message, Validators.required)
    });
  }

  save(): void {
    this.form.markAllAsTouched();
    this.chatService.savePredefinedMessage(this.form.getRawValue()).subscribe({
      next: () => this.ref.close(true)
    });
  }
}

interface IconMessageTypeMap {
  icon: string;
  type: MessageType;
  name: string;
}
